import React, { useCallback, useState } from "react";

export type OpenDrawerContextValue = {
  openDrawer: () => void;
  registerOpenDrawer: (fn: () => void) => void;
};

const noop = () => {};

const defaultValue: OpenDrawerContextValue = {
  openDrawer: noop,
  registerOpenDrawer: noop,
};

export const OpenDrawerContext = React.createContext<OpenDrawerContextValue>(defaultValue);

export function OpenDrawerProvider({ children }: { children: React.ReactNode }) {
  const [openDrawerFn, setOpenDrawerFn] = useState<() => void>(() => noop);

  const openDrawer = useCallback(() => {
    openDrawerFn();
  }, [openDrawerFn]);

  const registerOpenDrawer = useCallback((fn: () => void) => {
    setOpenDrawerFn(() => fn);
  }, []);

  const value: OpenDrawerContextValue = React.useMemo(
    () => ({ openDrawer, registerOpenDrawer }),
    [openDrawer, registerOpenDrawer]
  );

  return (
    <OpenDrawerContext.Provider value={value}>
      {children}
    </OpenDrawerContext.Provider>
  );
}
